import React from 'react'
import moment from 'moment'
import Verify from './verify'

let componentName = 'siteOrderCheck'

const columns = [
  {
    title: '场地名称',
    name: 'name',
    dataIndex: 'name',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '场地编号',
    name: 'code',
    dataIndex: 'code',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '预约人',
    name: 'fullName',
    dataIndex: 'fullName',
    tableItem: {}
  },
  {
    title: '联系电话',
    name: 'orderMobile',
    dataIndex: 'orderMobile',
    tableItem: {}
  },
  {
    title: '使用类型',
    name: 'useType',
    dict: [
      { code: 0, codeName: '新产品培训' },
      { code: 1, codeName: '实操培训' },
      { code: 2, codeName: '岗位培训' },
      { code: 3, codeName: '区域会议' },
      { code: 4, codeName: '岗位认证' },
      { code: 5, codeName: '其他' },
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {}
  },
  {
    title: '使用日期',
    name: 'useDate',
    dataIndex: 'useDate',
    tableItem: {},
    searchItem: {
      type: 'date',
      showTime: false,
      format: 'YYYY-MM-DD'
    }
  },
  {
    title: '是否核实',
    name: 'verify',
    dataIndex: 'verify',
    dict: [
      { code: 0, codeName: '否' },
      { code: 1, codeName: '是' }
    ],
    searchItem: {
      type: 'select',
    },
    tableItem: {}
  }
]

const templateConfig = {
  mainProps: {},
  content: {
    name: 'WizTableList',
    params: {
      columns,
      searchBarProps: {
        dataFormat: (params) => {
          let value = Object.assign({}, params)
          if (value.useDate) {
            value.useDate = moment(value.useDate).format('YYYY-MM-DD')
          }
          return value
        },
        
        buttonSort: ['batchVerify'],
        buttons: [
          {
            key: 'batchVerify',
            custom: true,
            needSelect: true,
            params: { children: '批量核实', type: 'primary' },
            customOnClick: {
              key: 'modal',
              params: {
                modalKey: 'batchCheckModal',
                modalParams: {
                  title: '场地预约批量审核',
                  footer: null,
                  width: 500,
                  diy: (e) => {
                    let rows = Object.assign([], e.rows)
                    return <Verify rows={rows} key={new Date().getTime()} changeModal={e.changeModal} />
                  }
                },
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: 'id',
        selectType: 'checkbox',
        isScroll: true,
        loading: false,
        needOnRowSelect: (record, index) => {
          return record.verify !== 1
        },
        rowSelection: {
          getCheckboxProps: (record) => {
            return { disabled: record.verify === 1 }
          }
        }
      },
      rowOperateSort: ['verify'],
      rowOperateView: [
        {
          key: 'verify',
          custom: true,
          params: { children: '核实' },
          customOnClick: {
            key: 'modal',
            params: {
              modalKey: 'checkModal',
              modalParams: {
                title: '场地预约核实',
                footer: null,
                diy: (e) => {
                  let record = Object.assign({}, e.record)
                  return <Verify key={record && record['id'] ? record['id'] : 'Verify'} record={record} changeModal={e.changeModal} />
                }
              },
            }
          },
          recordChangeParams: ({ record, rows }) => {
            return { disabled: record.verify === 1 }
          }
        }
      ]
    }
  }
}

const apis = (self) => {
  let managerPersonId = self && self._userInfo() && self._userInfo().personId
  return {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: { managerPersonId: managerPersonId || '-1' }
      }
    },
    check: {
      path: `${componentName}/check`,
      payload: {
        key: `${componentName}@check`,
        apiParams: {}
      }
    },
  }
}


let reduxTemplateCofig = (args) => {
  let { self, ...rest } = args
  return {
    apis: apis(self),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...rest
  }
}

export { reduxTemplateCofig, templateConfig }
